// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.voice-speak {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 13px;
  background: rgba(11, 15, 19, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  pointer-events: none;
  z-index: 38;
  animation: voice-fade 0.18s ease-out;
}
.voice-speak * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .voice-speak {
    animation: none;
  }
}
.voice-speak.is-quiet {
  padding: 6px 8px;
  background: rgba(11, 15, 19, 0.4);
}
.voice-speak__mic {
  flex: none;
  width: 17px;
  height: 17px;
  fill: none;
  stroke: #8d8a82;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.voice-speak.is-open .voice-speak__mic {
  stroke: var(--gold-light);
}
.voice-speak.is-muted .voice-speak__mic {
  stroke: #d9786d;
}
.voice-speak__slash {
  stroke: #d9786d;
  stroke-width: 2.2;
}
.voice-speak__title {
  font-size: 12.5px;
  font-weight: 600;
  color: #aeaba2;
  white-space: nowrap;
}
.voice-speak__meter {
  flex: none;
  display: inline-flex;
  align-items: flex-end;
  gap: 2px;
  height: 16px;
}
.voice-speak__meter > span {
  width: 2px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 1px;
  transition: background-color 0.08s ease;
}
.voice-speak__meter > span.is-on {
  background: var(--gold-main);
  opacity: 0.85;
}

.voice-range {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 200px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  background: rgba(11, 15, 19, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  pointer-events: none;
  z-index: 38;
  animation: voice-fade 0.18s ease-out;
}
.voice-range * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .voice-range {
    animation: none;
  }
}
.voice-range__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}
.voice-range__title {
  font-size: 12px;
  font-weight: 600;
  color: #8d8a82;
}
.voice-range__meters {
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
}
.voice-range__segments {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 3px;
}
.voice-range__segment {
  padding: 3px 0;
  font-size: 11.5px;
  font-weight: 600;
  text-align: center;
  color: #8d8a82;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  transition: background-color 0.12s ease, color 0.12s ease;
}
.voice-range__segment.is-active {
  color: #14100a;
  background: var(--gold-main);
  opacity: 0.9;
}

.voice-ring {
  --ring: var(--gold-main);
  position: fixed;
  left: 0;
  top: 0;
  pointer-events: none;
  z-index: 37;
  animation: voice-fade 0.18s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .voice-ring {
    animation: none;
  }
}
.voice-ring--whisper {
  --ring: #7fa6ff;
}
.voice-ring--normal {
  --ring: var(--gold-main);
}
.voice-ring--shout {
  --ring: #e8604f;
}
.voice-ring polyline {
  fill: none;
  stroke: var(--ring);
  stroke-width: 3.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 12 7;
  opacity: 0.95;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.7));
}

@keyframes voice-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/voiceHud/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAAA;EDwBE,yDAHU;EAIV,cAbK;ECVL,eAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAdK;EAeL,0CAAA;EACA,kBDKO;ECJP,oBAAA;EACA,WAAA;EACA,oCAAA;AAGF;ADQE;EAAI,sBAAA;ACLN;AAJE;EAjBF;IAiB4C,eAAA;EAQ1C;AACF;AANE;EAAa,gBAAA;EAAkB,iCAAA;AAUjC;AARE;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eDbK;ECcL,iBAAA;EACA,qBAAA;EACA,sBAAA;AAUJ;AAPE;EAAmB,yBAAA;AAUrB;AATE;EAAoB,eDnBb;AC+BT;AAVE;EACE,eDtBK;ECuBL,iBAAA;AAYJ;AATE;EACE,iBAAA;EACA,gBAAA;EACA,cD/BK;ECgCL,mBAAA;AAWJ;AAPE;EACE,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AASJ;AAPI;EACE,UAAA;EACA,qCAAA;EACA,kBAAA;EACA,uCAAA;AASN;AAPM;EAAU,4BAAA;EAA8B,aAAA;AAW9C;;AALA;ED5CE,yDAHU;EAIV,cAbK;EC0DL,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kCAlFK;EAmFL,0CAAA;EACA,kBD/DO;ECgEP,oBAAA;EACA,WAAA;EACA,oCAAA;AASF;ADlEE;EAAI,sBAAA;ACqEN;AAVE;EAjBF;IAiB4C,eAAA;EAc1C;AACF;AAbE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;AAeJ;AAZE;EACE,eAAA;EACA,gBAAA;EACA,cDnFK;ACiGT;AAXE;EACE,eAAA;EACA,gBAAA;EACA,cD1FK;ACuGT;AAVE;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AAYJ;AATE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cDvGK;ECwGL,qCAAA;EACA,kBAAA;EACA,yDAAA;AAWJ;AATI;EACE,cDzGM;EC0GN,4BAAA;EACA,YAAA;AAWN;;AAJA;EACE,wBAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,oBAAA;EACA,WAAA;EACA,oCAAA;AAOF;AALE;EATF;IAS4C,eAAA;EAS1C;AACF;AARE;EAAa,eAAA;AAWf;AAVE;EAAY,wBAAA;AAad;AAZE;EAAW,eAAA;AAeb;AAbE;EACE,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,+CAAA;AAeJ;;AAXA;EACE;IAAO,UAAA;EAeP;EAdA;IAAK,UAAA;EAiBL;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Voice HUD: never takes focus or clicks, and stays discreet (small, translucent, no glow). Two separate\n// pieces, see index.tsx.\n\n$veil: rgba(11, 15, 19, 0.55);\n$veil-line: rgba(255, 255, 255, 0.1);\n\n// The player's own voice, bottom centre\n.voice-speak {\n  @include ink.base;\n  position: fixed;\n  left: 50%;\n  bottom: 24px;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 13px;\n  background: $veil;\n  border: 1px solid $veil-line;\n  border-radius: ink.$radius;\n  pointer-events: none;\n  z-index: 38;\n  animation: voice-fade 0.18s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n\n  // Mic open with nothing said: just the icon\n  &.is-quiet { padding: 6px 8px; background: rgba(11, 15, 19, 0.4); }\n\n  &__mic {\n    flex: none;\n    width: 17px;\n    height: 17px;\n    fill: none;\n    stroke: ink.$text-3;\n    stroke-width: 1.8;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n  }\n\n  &.is-open &__mic { stroke: var(--gold-light); }\n  &.is-muted &__mic { stroke: ink.$danger; }\n\n  &__slash {\n    stroke: ink.$danger;\n    stroke-width: 2.2;\n  }\n\n  &__title {\n    font-size: 12.5px;\n    font-weight: 600;\n    color: ink.$text-2;\n    white-space: nowrap;\n  }\n\n  // Level of the voice: bars that light up\n  &__meter {\n    flex: none;\n    display: inline-flex;\n    align-items: flex-end;\n    gap: 2px;\n    height: 16px;\n\n    > span {\n      width: 2px;\n      background: rgba(255, 255, 255, 0.12);\n      border-radius: 1px;\n      transition: background-color 0.08s ease;\n\n      &.is-on { background: var(--gold-main); opacity: 0.85; }\n    }\n  }\n}\n\n// How far the voice carries, at the right: only when the player switches it\n.voice-range {\n  @include ink.base;\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  width: 200px;\n  padding: 8px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  background: $veil;\n  border: 1px solid $veil-line;\n  border-radius: ink.$radius;\n  pointer-events: none;\n  z-index: 38;\n  animation: voice-fade 0.18s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n\n  &__head {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 10px;\n  }\n\n  &__title {\n    font-size: 12px;\n    font-weight: 600;\n    color: ink.$text-3;\n  }\n\n  &__meters {\n    font-size: 14px;\n    font-weight: 600;\n    color: ink.$text-2;\n  }\n\n  &__segments {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 3px;\n  }\n\n  &__segment {\n    padding: 3px 0;\n    font-size: 11.5px;\n    font-weight: 600;\n    text-align: center;\n    color: ink.$text-3;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 4px;\n    transition: background-color 0.12s ease, color 0.12s ease;\n\n    &.is-active {\n      color: ink.$on-accent;\n      background: var(--gold-main);\n      opacity: 0.9;\n    }\n  }\n}\n\n// The ring of the range, on the ground around the player: the colour tells the range (whisper blue, speak\n// gold, shout red)\n.voice-ring {\n  --ring: var(--gold-main);\n  position: fixed;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  z-index: 37;\n  animation: voice-fade 0.18s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n\n  &--whisper { --ring: #7fa6ff; }\n  &--normal { --ring: var(--gold-main); }\n  &--shout { --ring: #e8604f; }\n\n  polyline {\n    fill: none;\n    stroke: var(--ring);\n    stroke-width: 3.5;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-dasharray: 12 7;\n    opacity: 0.95;\n    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.7));\n  }\n}\n\n@keyframes voice-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
